// extracted by mini-css-extract-plugin
export var buttons = "_3a-0";
export var buttonsActive = "_3a-h";
export var cancelConfirm = "_3a-1";
export var closeButton = "_3a-2";
export var column = "_3a-3";
export var container = "_3a-4";
export var detailHeader = "_3a-6";
export var detailTitle = "_3a-7";
export var detailsContent = "_3a-5";
export var header = "_3a-8";
export var headerWithClose = "_3a-9";
export var icon = "_3a-a";
export var infoIcon = "_3a-c";
export var informationContainer = "_3a-b";
export var sideDrawer = "_3a-d";
export var sideDrawerOpen = "_3a-e";
export var stickyFooter = "_3a-f";
export var typeOption = "_3a-g";